import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";

const Control = ({ sessionId, sendRotateCall, controlData }) => {
  const [controlStates, setControlStates] = useState({});

  useEffect(() => {
    if (controlData?.length) {
      const initialStates = {};
      controlData.forEach((control) => {
        if (control.control_data_type === "boolean") {
          initialStates[control.control_id] = control.default_value === true;
        }
      });
      setControlStates(initialStates);
    }
  }, [controlData]);

  const handleToggle = (control) => {
    const isBoolean = control.control_data_type === "boolean";
    const currentValue = controlStates?.[control.control_id] ?? false;
    const newValue = isBoolean ? !currentValue : true;

    const payload = {
      session_id: sessionId,
      message: {
        type: "control",
        message: {
          control_id: control.control_id,
          value: newValue.toString(),
        },
      },
    };

    sendRotateCall(payload);

    if (isBoolean) {
      setControlStates((prev) => ({
        ...prev,
        [control.control_id]: newValue,
      }));
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "10px",
        transform: "translateY(-50%)",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "5px",
          borderRadius: "15px",
          gap: "10px",
          backgroundColor: "#EEEDEB",
        }}
      >
        {controlData?.map((control) => {
          const icon = control?.control_icons?.find(
            (icon) => icon.file_type === "L"
          );
          const isBoolean = control.control_data_type === "boolean";
          const isSelected = isBoolean && controlStates?.[control.control_id];

          return (
            <Box
              key={control.control_id}
              sx={{
                backgroundColor: isSelected ? "white" : "transparent",
                borderRadius: "10px",
              }}
            >
              <Tooltip title={control.control_name}>
                <IconButton onClick={() => handleToggle(control)}>
                  <img
                    src={icon?.path}
                    alt={control.control_name}
                    style={{ width: 18, height: 18 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          );
        })}
      </Paper>
    </Box>
  );
};

export default Control;
